

    // Ingredient slide
    const ingredientMain = document.querySelector('.ingredient_slideMain');

    if (ingredientMain) {
        const ingredientEl = document.querySelector('.ingredient_slideContent');
        const ingredientAutoplay = ingredientEl.getAttribute('data-autoplay') === 'true';
        const ingredientAutoplaySpeed = parseInt(ingredientEl.getAttribute('data-autoplay-speed'), 10) || 3000;

        // Initialize the Splide slider
        const ingredient_splide = new Splide('.ingredient_slideContent', {
            type       : 'loop',
            autoplay  : ingredientAutoplay,
            interval  : ingredientAutoplaySpeed,
            pauseOnHover: true,
            perPage   : 5,
            perMove   : 1,
            gap       : '1.6rem',
            pagination: false,
            arrows: true,
            drag: true,
            wheel: false,
            breakpoints: {
                1440: {
                    perPage: 4,
                },
                1199: {
                    perPage: 3,
                },
                989: {
                    perPage: 2,
                    gap: "2rem",
                },
                575: {
                    perPage: 1,
                    gap: "1.5rem",
                    padding: { right: '6rem' },
                }
            }
        }).mount();

        // Trackpad horizontal swipe support (left/right), ignoring vertical scroll
        let ingredientWheelLock = false;
        ingredientEl.addEventListener('wheel', function (e) {
            if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 10) {
                e.preventDefault();
                if (ingredientWheelLock) return;
                ingredientWheelLock = true;
                ingredient_splide.go(e.deltaX > 0 ? '>' : '<');
                setTimeout(function () { ingredientWheelLock = false; }, 600);
            }
        }, { passive: false });
    }
    // Ingredient slide

    // Video testimonial slide
    const videoTestiMain = document.querySelector('.videoTestiMain');

    if (videoTestiMain) {
        // Initialize the Splide slider
        const video_testi_splide = new Splide('.video_testi_slide', {
            type       : 'slide',
            autoplay   : false,
            pauseOnHover: false,
            perPage    : 4,
            perMove    : 1,
            gap        : '2rem',
            pagination : false,
            arrows     : true,
            drag       : true,
            wheel      : false,
            breakpoints: {
                1199: {
                    perPage: 3,
                },
                989: {
                    perPage: 2.4,
                    gap: "1.6rem",
                },
                749: {
                    perPage: 2,
                    gap: "0.4rem",
                    arrows: true,
                }
            }
        }).mount();

        // Trackpad horizontal swipe support (left/right), ignoring vertical scroll
        const videoTestiEl = document.querySelector('.video_testi_slide');
        let videoTestiWheelLock = false;
        videoTestiEl.addEventListener('wheel', function (e) {
            if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 10) {
                e.preventDefault();
                if (videoTestiWheelLock) return;
                videoTestiWheelLock = true;
                video_testi_splide.go(e.deltaX > 0 ? '+1' : '-1');
                setTimeout(function () { videoTestiWheelLock = false; }, 600);
            }
        }, { passive: false });

        // Custom play/pause (native controls removed so touch-swipe isn't blocked)
        document.querySelectorAll('.videoTestiMain .video_inner').forEach(function (inner) {
            const video = inner.querySelector('video');
            const btn = inner.querySelector('.playBtn');
            if (!video) return;
            inner.addEventListener('click', function () {
                if (video.paused) {
                    video.play();
                    if (btn) btn.style.display = 'none';
                } else {
                    video.pause();
                    if (btn) btn.style.display = '';
                }
            });
            video.addEventListener('ended', function () {
                if (btn) btn.style.display = '';
            });
            video.addEventListener('pause', function () {
                if (btn) btn.style.display = '';
            });
        });
    }
    // Video testimonial slide

    // Related blog slide
    const related_blogMain = document.querySelector('.relatedBlog_main');

    if (related_blogMain) {
        // Initialize the Splide slider
        const relatedBlog_splide = new Splide('.relatedBlog_slide', {
            type         : 'loop',
            autoplay     : false,
            interval     : 3000,
            pauseOnHover : false,
            perPage      : 5,
            perMove      : 1,
            gap          : '3.2rem',
            pagination   : false,
            arrows       : true,
            drag         : true,
            wheel        : false,
            breakpoints: {
                1600: {
                    perPage  : 4,
                    gap      : '3rem',
                },
                1199: {
                    perPage  : 3,
                },
                989: {
                    perPage  : 2,
                    gap      : "2rem",
                },
                575: {
                    perPage  : 1,
                    gap      : "1.5rem",
                }
            }
        }).mount();

        // Trackpad horizontal swipe support (left/right), ignoring vertical scroll
        const relatedBlogEl = document.querySelector('.relatedBlog_slide');
        let relatedBlogWheelLock = false;
        relatedBlogEl.addEventListener('wheel', function (e) {
            if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 10) {
                e.preventDefault();
                if (relatedBlogWheelLock) return;
                relatedBlogWheelLock = true;
                relatedBlog_splide.go(e.deltaX > 0 ? '+1' : '-1');
                setTimeout(function () { relatedBlogWheelLock = false; }, 600);
            }
        }, { passive: false });
    }
    // Related blog slide